import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

// CSS imports (these can't be lazy loaded)
import 'animate.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'remixicon/fonts/remixicon.css'
import './assets/css/style.css';

// Lazy load all components
const Main = lazy(() => import('./components/Website/Pages/Main'));
const Home = lazy(() => import('./components/Website/Pages/Home'));
const Profile_card = lazy(() => import('./components/Common/Profile_card'));
const Principal = lazy(() => import('./components/Website/Pages/Principal'));
const Chairman = lazy(() => import('./components/Website/Pages/Chairman'));
const Bog = lazy(() => import('./components/Website/Pages/Bog'));
const About = lazy(() => import('./components/Website/Pages/About'));
const Syllabus = lazy(() => import('./components/Website/Pages/Syllabus'));
const Syllabus_card = lazy(() => import('./components/Common/Syllabus_card'));
const Recommended_Book = lazy(() => import('./components/Website/Pages/Recommended_Book'));
const Book_card = lazy(() => import('./components/Common/Book_card'));
const Fee_Structure = lazy(() => import('./components/Website/Pages/Fee_Structure'));
const PasswordInput = lazy(() => import('./components/Website/Pages/PasswordInput'));
const SimpleSlider = lazy(() => import('./components/Common/MySlider'));
const Contact = lazy(() => import('./components/Website/Pages/Contact'));
const VirtualTour = lazy(() => import('./components/Website/Pages/VirtualTour'));
const Picturial_Tour = lazy(() => import('./components/Website/Pages/Picturial_Tour'));
const Feature_card = lazy(() => import('./components/Common/Feature_card'));
const Feature_cources = lazy(() => import('./components/Website/Pages/Feature_cources'));
const Admission_card = lazy(() => import('./components/Common/Admission_card'));
const Admission_criteria = lazy(() => import('./components/Website/Pages/Admission_criteria'));
const Admission_Procedure = lazy(() => import('./components/Website/Pages/Admission_Procedure'));
const Uniform = lazy(() => import('./components/Website/Pages/Uniform'));
const Practice = lazy(() => import('./components/Website/Pages/Practice'));
const Cards = lazy(() => import('./components/Common/Cards'));
const Pagination = lazy(() => import('./components/Website/Shared/pagination'));
const WebNews = lazy(() => import('./components/Website/Pages/News'));
const Error = lazy(() => import('./components/Website/Pages/Error'));
const AllNews = lazy(() => import('./components/Website/Pages/UpCommingNews'));
const ViewNews = lazy(() => import('./components/Website/Pages/ViewNews'));
const ClassLevel = lazy(() => import('./components/Website/Pages/ClassLevel'));
const Newsletter = lazy(() => import('./components/Website/Pages/Newsletter'));
const OfficialNews = lazy(() => import('./components/Website/Pages/OfficialNews'));
const UpCommingNews = lazy(() => import('./components/Website/Pages/UpCommingNews'));
const FloatButton = lazy(() => import('./components/Website/Pages/FloatButton'));
const Timer = lazy(() => import('./components/Website/Pages/CountDownShow'));
const PrintVouchers = lazy(() => import('./components/Website/Pages/PrintVouchers'));
const PrintChallan = lazy(() => import('./components/Website/Pages/PrintChallan'));
const PrivacyPolicy = lazy(() => import('./components/Website/Pages/PrivacyPolicy'));

// // Admin components
// const AdminMain = lazy(() => import('./components/Admin/AdminMain'));
// const Dashboard = lazy(() => import('./components/Admin/Dashboard'));
// const Banners = lazy(() => import('./components/Admin/Banners'));
// const Content = lazy(() => import('./components/Admin/ContentPage/Content'));
// const AddContent = lazy(() => import('./components/Admin/ContentPage/AddContent'));
// const EditContent = lazy(() => import('./components/Admin/ContentPage/EditContent'));
// const Events = lazy(() => import('./components/Admin/Events/Events'));
// // const Videos = lazy(() => import('./components/Admin/Videos'));
// const EditNews = lazy(() => import('./components/Admin/News/EditNews'));
// const AddNews = lazy(() => import('./components/Admin/News/AddNews'));
// const Photos = lazy(() => import('./components/Admin/Photos/Photos'));
// const Login = lazy(() => import('./components/Admin/Login/Login'));
// const AddEvents = lazy(() => import('./components/Admin/Events/AddEvents'));
// const EditEvents = lazy(() => import('./components/Admin/Events/EditEvents'));
// const EditPhotos = lazy(() => import('./components/Admin/Photos/EditPhotos'));
// const AddPhotos = lazy(() => import('./components/Admin/Photos/AddPhotos'));
// const ManageNews = lazy(() => import('./components/Admin/News/News'));



// Admin
const AdminMain = lazy(() => import("./components/Admin/AdminMain"));
const Dashboard = lazy(() => import("./components/Admin/Dashboard"));
const Banners = lazy(() => import("./components/Admin/Banners"));
const Content = lazy(() => import("./components/Admin/ContentPage/Content"));
const AddContent = lazy(() => import("./components/Admin/ContentPage/AddContent"));
const EditContent = lazy(() => import("./components/Admin/ContentPage/EditContent"));
const Events = lazy(() => import("./components/Admin/Events/Events"));
const VoucherSetting = lazy(() => import("./components/Admin/VoucherSetting"));
const News = lazy(() => import("./components/Admin/News/News"));
const EditNews = lazy(() => import("./components/Admin/News/EditNews"));
const AddNews = lazy(() => import("./components/Admin/News/AddNews"));
const Photos = lazy(() => import("./components/Admin/Photos/Photos"));
const Login = lazy(() => import("./components/Admin/Login/Login"));
const AddEvents = lazy(() => import("./components/Admin/Events/AddEvents"));
const EditEvents = lazy(() => import("./components/Admin/Events/EditEvents"));
const EditPhotos = lazy(() => import("./components/Admin/Photos/EditPhotos"));
const AddPhotos = lazy(() => import("./components/Admin/Photos/AddPhotos"));
const ManageAdministration = lazy(() => import("./components/Admin/Administration/ManageAdministration"));
const EditAdministration = lazy(() => import("./components/Admin/Administration/EditAdministration"));
const AddAdministration = lazy(() => import("./components/Admin/Administration/AddAdministration"));
const ManageBOG = lazy(() => import("./components/Admin/BOG/ManageBOG"));
const EditBOG = lazy(() => import("./components/Admin/BOG/EditBOG"));
const AddBOG = lazy(() => import("./components/Admin/BOG/AddBOG"));
const ManageMessage = lazy(() => import("./components/Admin/Message/ManageMessage"));
const EditMessage = lazy(() => import("./components/Admin/Message/EditMessage"));
const AddMessage = lazy(() => import("./components/Admin/Message/AddMessage"));
const ChangePassword = lazy(() => import("./components/Admin/ChangePassword"));


// Loading component
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    backgroundColor: '#f8f9fa'
  }}>
    <div className="text-center">
      <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
      <h5 className="text-muted">Loading page...</h5>
    </div>
  </div>
);

function Index() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/print-vouchers/print-challan" element={<PrintChallan />} />
          
          <Route path='/' element={<Main />}>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/bog" element={<Bog />} />
            <Route path="/about" element={<About />} />
            <Route path="/principal" element={<Principal />} />
            <Route path="/chairman" element={<Chairman />} />
            <Route path="/profile" element={<Profile_card />} />
            <Route path="/syllabus" element={<Syllabus />} />
            <Route path="/syllabus_card" element={<Syllabus_card />} />
            <Route path="/recommended_book" element={<Recommended_Book />} />
            <Route path="/book_card" element={<Book_card />} />
            <Route path="/fee_structure" element={<Fee_Structure />} />
            {/* <Route path="/passwordinput" element={<PasswordInput />} /> */}
            <Route path="/myslider" element={<SimpleSlider />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/images" element={<VirtualTour />} />
            <Route path="/events" element={<Picturial_Tour />} />
            <Route path="/feature_card" element={<Feature_card />} />
            <Route path="/feature_cources" element={<Feature_cources />} />
            <Route path="/admission_card" element={<Admission_card />} />
            <Route path="/admission_criteria" element={<Admission_criteria />} />
            <Route path="/admission_procedure" element={<Admission_Procedure />} />
            <Route path="/uniform" element={<Uniform />} />
            {/* <Route path="/practice" element={<Practice />} /> */}
            <Route path="/cards" element={<Cards />} />
            <Route path="/pagination" element={<Pagination />} />
            <Route path="/floatButton" element={<FloatButton />} />
            <Route path="/news/upcommingnews" element={<UpCommingNews />} />
            <Route path="/news/viewnews/:id" element={<ViewNews />} />
            <Route path="/classlevel" element={<ClassLevel />} />
            <Route path="/news/newsletter" element={<Newsletter />} />
            <Route path="/news/officialnews" element={<OfficialNews />} />
            <Route path="/timer" element={<Timer />} />
            <Route path="/print-vouchers" element={<PrintVouchers />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<Error />} />
          </Route>

          <Route path='/web-admin/login' element={<Login />} />

          {/* <Route path="/web-admin" element={<AdminMain />}>
            <Route path="/web-admin/dashboard" element={<Dashboard />} />
            <Route path="/web-admin/banners" element={<Banners />} />
            <Route path="/web-admin/content" element={<Content />} />
            <Route path="/web-admin/add-Content" element={<AddContent />} />
            <Route path="/web-admin/edit-Content/:id" element={<EditContent />} />
            <Route path="/web-admin/videos" element={<Videos />} />
            <Route path="/web-admin/events" element={<Events />} />
            <Route path="/web-admin/edit-events/:id" element={<EditEvents />} />
            <Route path="/web-admin/add-events" element={<AddEvents />} />
            <Route path="/web-admin/news" element={<ManageNews />} />
            <Route path="/web-admin/news/:id" element={<EditNews />} />
            <Route path="/web-admin/add-news" element={<AddNews />} />
            <Route path="/web-admin/photos" element={<Photos />} />
            <Route path="/web-admin/edit-photos/:id" element={<EditPhotos />} />
            <Route path="/web-admin/add-photos" element={<AddPhotos />} />
            <Route path="*" element={<Error />} />
          </Route> */}

           <Route path="/web-admin" element={<AdminMain />}>
            <Route path="/web-admin/change-password" element={<ChangePassword />} />
            <Route path="/web-admin/dashboard" element={<Dashboard />} />
            <Route path="/web-admin/banners" element={<Banners />} />
            <Route path="/web-admin/content" element={<Content />} />
            <Route path="/web-admin/add-Content" element={<AddContent />} />
            <Route path="/web-admin/edit-Content/:id" element={<EditContent />} />
            <Route path="/web-admin/voucher-setting" element={<VoucherSetting />} />
            <Route path="/web-admin/events" element={<Events />} />
            <Route path="/web-admin/edit-events/:id" element={<EditEvents />} />
            <Route path="/web-admin/add-events" element={<AddEvents />} />
            <Route path="/web-admin/news" element={<News />} />
            <Route path="/web-admin/news/:id" element={<EditNews />} />
            <Route path="/web-admin/add-news" element={<AddNews />} />
            <Route path="/web-admin/administration" element={<ManageAdministration />} />
            <Route path="/web-admin/administration/:id" element={<EditAdministration />} />
            <Route path="/web-admin/add-administration" element={<AddAdministration />} />
            <Route path="/web-admin/bog" element={<ManageBOG />} />
            <Route path="/web-admin/bog/:id" element={<EditBOG />} />
            <Route path="/web-admin/add-bog" element={<AddBOG />} />
            <Route path="/web-admin/message" element={<ManageMessage />} />
            <Route path="/web-admin/message/:id" element={<EditMessage />} />
            <Route path="/web-admin/add-message" element={<AddMessage />} />
            <Route path="/web-admin/photos" element={<Photos />} />
            <Route path="/web-admin/edit-photos/:id" element={<EditPhotos />} />
            <Route path="/web-admin/add-photos" element={<AddPhotos />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Index />);